import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';

interface UserProfile {
  firstName: string;
  lastName: string;
  displayName: string;
  email: string;
}

export const useUserProfile = () => {
  const { user } = useAuth();
  const [profile, setProfile] = useState<UserProfile | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfile = async () => {
      if (!user?.email) {
        setLoading(false);
        return;
      }

      try {
        // Try to get the name from application_progress
        const { data: appProgress } = await supabase
          .from('application_progress')
          .select('application_data')
          .eq('email', user.email)
          .maybeSingle();

        if (appProgress?.application_data) {
          const appData = appProgress.application_data as any;
          const contact = appData?.contact;
          
          if (contact?.firstName || contact?.lastName) {
            const firstName = contact.firstName || '';
            const lastName = contact.lastName || '';
            setProfile({
              firstName,
              lastName,
              displayName: firstName ? `${firstName}${lastName ? ` ${lastName}` : ''}` : user.email,
              email: user.email
            });
            setLoading(false);
            return;
          }
        }

        // Fallback to just email
        setProfile({
          firstName: '',
          lastName: '',
          displayName: user.email,
          email: user.email
        });
      } catch (error) {
        console.error('Error fetching user profile:', error);
        setProfile({
          firstName: '',
          lastName: '',
          displayName: user.email,
          email: user.email
        });
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [user?.email]);

  return { profile, loading };
};
